
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.392 17.958c-1.308-.272-2.27-1.593-2.136-2.923-.31-1.022 1.417-1.38 1.467-.293-.036.72.181 1.614 1.012 1.747 2.549.102 5.107.041 7.66.04.75.09 1.627-.146 1.86-.956l.02-8.888c-.917-.048-1.858.063-2.753-.166-1.182-.396-1.993-1.625-1.862-2.87.002-.716.01-1.432.014-2.147l-5.02.02c-.574.21-.98.779-.894 1.402.078.655-.05 1.771-.972 1.551-.85-.303-.442-1.384-.509-2.061.1-1.221 1.2-2.309 2.418-2.396 2.049.016 4.1-.041 6.147.044 1.084.197 1.675 1.196 2.399 1.916.748.88 1.64 1.658 2.235 2.654.476.988.218 2.123.293 3.177-.012 2.651.011 5.309-.029 7.956-.275 1.272-1.462 2.344-2.802 2.23-2.814.02-5.63.038-8.442-.024l-.106-.013zm9.636-12.839c-.941-1.09-1.921-2.146-2.87-3.23.022.807-.017 1.629.041 2.426.294.822 1.23.915 1.978.86.28-.014.58.026.85-.056zm-8.894 8.476c-.741-.219-.583-1.475.214-1.441.989.062 2.01-.372 2.523-1.245.864-1.316.143-3.29-1.36-3.744-1.265-.471-2.764.269-3.226 1.524.48-.522 1.487-.14 1.327.621-.34.742-1.038 1.282-1.535 1.93-.335.423-.721.968-1.07.252-.585-.713-1.286-1.363-1.75-2.157-.219-.841 1.065-1.24 1.424-.487C3.01 6.87 4.978 5.35 6.976 5.531c2.08.09 3.832 2.011 3.77 4.086.039 2.102-1.811 4.006-3.911 4.02-.233.005-.473.021-.7-.042z"}})])
          )
        }
      }
    